import Api from '@/store/api'

const state = {
  lastFetch: null,
  list:  null
}

const actions = {
  getAll({commit}) {
    // let now = new Date()
    // if ((now.getTime() - state.lastFetch.getTime()) > 24) {
    Api.getImages(function(response) {
      commit('set_images', response.entries)
    })
    // }
  }

}

const mutations = {
  set_images (state, payload) {
    state.list = payload
    state.lastFetch = new Date()
  }
}

export default  {
  namespaced: true,
  state,
  mutations,
  actions
}
